<template>
  <div class="card-wrapper" ref="wrapper">
    <!--头部-->
    <div class="head box">
      <div class="box">
        <div class="btn" @click="clickActive" :class="type == 'active'?'active':''">活动</div>
        <div class="btn" @click="clickCaogao" :class="type == 'caogao'?'active':''">草稿</div>
      </div>
      <Button type="primary" @click="newActivity">新建活动</Button>
    </div>
    <!--活动列表-->
    <div class="activityList box">
      <div
        v-for="(item,index) in activityList"
        :key="index"
        @mouseenter="cardHover(index)"
        @mouseleave="cardHover(index)"
        style="position:relative;margin-bottom:20px"
        :style="{marginRight: cardMargin+'px'}"
        @click="router(item.id)"
      >
        <Poptip placement="bottom-end" class="editIcon" trigger="hover" width="130">
          <div class="iconfont icon-caidan1 card-menu" v-if="index==isHoverIndex && isHover"></div>
          <div slot="content">
            <div class="box-v pop-wrapper">
              <div
                :style="{background:changeState=='chehui'?'#f1f1f1':''}"
                @mouseover="change('chehui')"
                @mouseout="change('')"
                v-if="type == 'active'"
                @click="backActiveDraft(item.state,item.id)"
              >撤回</div>
              <!--<Divider />-->
              <div
                :style="{background:changeState=='shanchu'?'#f1f1f1':''}"
                @mouseover="change('shanchu')"
                @mouseout="change('')"
                v-else
                @click="deleteMe(item)"
              >删除</div>
            </div>
          </div>
        </Poptip>

        <Card class="active-warpper" :padding="0">
          <div v-if="type == 'active'">
            <div
              class="triangle"
              :style="{borderTopColor: item.activeFlag == 1?'#47ba53':item.activeFlag==2?'#a1afb2':'#ff7b43'}"
            ></div>
            <div class="triangle-info">{{item.cnstate}}</div>
          </div>
          <div style="width: 87.87%;margin: 20px auto;">
            <img v-if="item.coverPicUrl" :src="item.coverPicUrl" class="coverimg">
            <div v-else class="zhanwei">暂无封面图</div>
          </div>

          <div class="title1">{{item.title?item.title:'暂无标题'}}</div>
          <div class="footer" v-if="type == 'active'">
            <div class>
              <span class="iconfont icon-chakan delete-text"></span>
              <span class="number">{{item.previewNumber}}</span>
            </div>
            <div class>
              <span class="iconfont icon-pinglun3 delete-text"></span>
              <span class="number">{{item.messageNumber}}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
    <div class="box" style="justify-content: flex-end;padding-right: 20px">
      <Page :total="total" show-total @on-change="pageChange"  />
    </div>
    <!--撤销弹窗-->
    <Modal v-model="chexiao" @on-ok="ok" :mask-closable="false">
      <p style="text-align:center;height:50px;line-height:50px;font-size:20px;">确定撤销？</p>
    </Modal>
    <!--删除弹窗-->
    <Modal v-model="shanchu" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <!--<Icon type="information-circled"></Icon>-->
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>是否确认删除？</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="del()" :loading="shanchuIng">删除</Button>
      </div>
    </Modal>
    <Spin fix v-if="showSpin">
    </Spin>
  </div>
</template>

<script>
  export default {
    name: 'orgActive',
    props:{
      id:null,
      comeType: null
    },
    data () {
      return {
        type:'active',//active活动  caogao草稿
        isHover: false, //卡片是否悬浮
        isHoverIndex: 0,
        changeState: "",
        chexiao: false,
        activityId: "", //撤回用id
        activityState: "",
        shanchu: false,
        shanchuIng: false,
        actid: "" ,//删除用id
        activityList:[],
        contentWidth:1510,
        page:1,
        rows:10,
        showSpin:false,
        total:0,
      }
    },
    watch:{
      id (newV,oldV) {
        this.getActiveList()
      },
      type () {
        this.getActiveList()
      }
    },
    //监听属性 类似于data概念
    computed: {
      cardMargin() {
        let cardNumber = parseInt(this.contentWidth / 328);
        let totalMargin = this.contentWidth - cardNumber * 328;
        return totalMargin / (cardNumber + 1);
      }
    },
    methods:{
      getActiveList () {

        this.showSpin = true
        var url = this.urlobj.getOrgActive
        this.$post(url,{
          orgId:this.id,
          pageNum:this.page,
          pageSize:this.rows,
          isSend:this.type == 'active'?1:0,
          comeType: this.comeType
        }).then(res => {
          this.total = res.total
          this.showSpin = false
          this.activityList = res.rows.map(item => {
            return {
              activeFlag:this.handleTime(item.status).activeFlag,
              cnstate:this.handleTime(item.status).cnstate,
              state:1,
              id:item.id,
              coverPicUrl:item.coverPicUrl,
              title:item.title,
              previewNumber:item.previewNumber,
              messageNumber:item.messageNumber,
            }
          })
        })
      },
      // 页码改变
      pageChange (num) {
        this.page = num
        this.getActiveList()
      },
      handleTime(status) {
        switch(status) {
          case 1: 
            return {
              activeFlag: 3,
              cnstate: "进行中"
            }
            break
          case 2: 
            return {
              activeFlag: 2,
              cnstate: "未开始"
            }
            break
          case 3: 
            return {
              activeFlag: 1,
              cnstate: "已结束"
            }
            break
        }
        // if (Date.now() > new Date(Number(endTime))) {
        //   return {
        //     activeFlag: 1,
        //     cnstate: "已结束"
        //   }
        // } else if (Date.now() < new Date(Number(beginTime))) {
        //   return {
        //     activeFlag: 2,
        //     cnstate: "未开始"
        //   }
        // } else if (
        //   Date.now() <= new Date(Number(endTime)) &&
        //   Date.now() >= new Date(Number(beginTime))
        // ) {
        //   return {
        //     activeFlag: 3,
        //     cnstate: "进行中"
        //   }

        // }
      },
      clickActive () {
        this.type = 'active'
      },
      clickCaogao () {
        this.type = 'caogao'
      },
      //卡片悬停显示点点点图标
      cardHover(index) {
        this.isHoverIndex = index;
        this.isHover = !this.isHover;
      },
      change(item) {
        this.changeState = item;
      },
      router(id) {
        if (this.type == 'active') {
          this.$router.push({ name: "activitydetail", query: { id } });
        } else {
          this.$router.push({ name: "newactivity", query: { id } });
        }
      },
      backActiveDraft(num, id) {
        //点击撤销    弹出model
        event.stopPropagation();
        if (num == 1) {
          this.chexiao = true;
        }
        this.activityId = id;
        this.activityState = num;
      },
      ok() {
        var that = this;
        if (this.activityState == 1) {
          var url = this.urlobj.activeDel(this.activityId) + `?isDelete=0`;
          this.$delete(url).then(function(res) {
            that.getActiveList()
          });
        }
      },
      deleteMe(val) {
        event.stopPropagation();
        this.shanchu = true;
        this.actid = val.id;
        this.activityState = val.num;
      },
      del() {
        var that = this;
        that.shanchuIng = true;
        var url = this.urlobj.activeDel(this.actid) + `?isDelete=1`;
        this.$delete(url).then(function(res) {
          that.shanchu = false;
          that.shanchuIng = false;
          that.getActiveList()
        });
      },
      //打开新增活动页面
      newActivity() {
        this.$router.push({name: "newactivity", query: {state: 'org'}});
      },
    },
    created() {
      /**内容框宽度 */
      this.$nextTick(function() {
        this.contentWidth = this.$refs.wrapper.offsetWidth;
      });
      /**页面高度改变时内容框宽度 */
      window.onresize = () => {
        return (() => {
          this.contentWidth = this.$refs.wrapper && this.$refs.wrapper.offsetWidth;
        })();
      };
    },
  }
</script>

<style scoped lang="less">
  .card-wrapper /deep/ .ivu-btn{
    padding: 1px 15px 2px;
  }
  .card-wrapper /deep/ .ivu-page-item{
    background: #f1f1f1;
  }
  .card-wrapper /deep/ .ivu-page-prev, .ivu-page-next{
    background: #f1f1f1;
  }
  .card-wrapper /deep/ .ivu-page-next{
    background: #f1f1f1 ;
  }
  .card-wrapper {
    width: 98%;
    margin: auto;
    position: relative;
  }
  .head {
    justify-content: space-between;
    line-height: 1;
    margin-bottom: 20px;
    .btn{
      height: 30px;
      line-height: 30px;
      width: 50px;
      text-align: center;
      background: #fff;
      color:#999;
      &:first-child{
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child{
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active{
      background: #ff7b44;
      color:#fff
    }
  }
  .activityList {
    flex-wrap: wrap;
  }
  // 卡片样式
  .active-warpper {
    width: 328px;
  }
  .editIcon {
    position: absolute;
    margin-top: 25px;
    margin-left: 270px;
    z-index: 999;
    &:hover {
      cursor: pointer;
    }
  }
  .card-menu {
    font-size: 25px;
    color: #fff;
    background-color: rgba(0, 0, 0, .3);
    line-height: 0.8em;
    width: 30px;
    text-align: center;
    border-radius: 30px;
  }
  .coverimg {
    display: inline-block;
    width: 100%;
    height: 200px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .zhanwei {
    background: #ddd;
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
  .title1 {
    padding: 0 20px;
    margin-bottom: 20px;
    // box-sizing: content-box;
    color: #4b4b4b;
    font-size: 18px;
    height: 2.4em;
    line-height: 1.2em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #eee;
    height: 46px;

    .delete-text {
      font-size: 20px;
    }
    .number {
      margin: 0 48px 0 10px;
      color: #666;
      font-size: 15px;
      vertical-align: text-bottom;
    }
  }
  .pop-wrapper {
    text-align: center;
    letter-spacing: 20px;
    color: #999;
  }
  .triangle {
    position: absolute;
    top: 20px;
    left: 19px;
    width: 0;
    height: 0;
    border-top: 60px solid #47ba53;
    border-right: 60px solid transparent;
  }
  .triangle-info {
    position: absolute;
    top: 30px;
    left: 20px;
    color: #fff;
    transform: rotate(-45deg);
  }
</style>
